import loadingDictionary from '@widgets/loading/i18n/ru/loading.dic.json';

export const loading = {
  LOADING: loadingDictionary,
};

export const loadingNamespaces = ['LOADING'];
